import { Mask } from "./Mask";

export class CurrencyMask implements Mask {
  maxLength: number = 15;

  execute(value: string) {
    // Remove todos os caracteres não numéricos
    let numericValue = value.replace(/\D/g, "");

    // Limita o número de dígitos (15 permite até 999.999.999.999,99)

    numericValue = numericValue.substring(0, this.maxLength);

    if (!numericValue) return "";

    // Adiciona zeros à esquerda para garantir pelo menos 3 dígitos
    numericValue = numericValue.padStart(3, "0");

    // Divide em parte inteira e decimal
    const integerPart = numericValue.slice(0, -2).replace(/^0+/, "") || "0";
    const decimalPart = numericValue.slice(-2);

    // Formata a parte inteira com separadores de milhar
    const formattedInteger =
      integerPart
        .split("")
        .reverse()
        .join("")
        .match(/.{1,3}/g)
        ?.join(".")
        .split("")
        .reverse()
        .join("") || "0";

    // if (numericValue.length === this.maxLength) {
    return `R$ ${formattedInteger},${decimalPart}`;
    // }
    // return numericValue;
  }

  format(value: number, maximumFractionDigits = 2): string {
    // \u00A0
    if (!value) return "R$ 0,00";
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
      maximumFractionDigits,
    }).format(value);
  }
}
